module.exports = __webpack_public_path__ + "img/ping-monitoring.1916e377.png";